import axios from 'axios';
import { validAttributes } from './constant';

export const customFilter = (option, searchText) => {
  if (
    option.data.label.toLowerCase().includes(String(searchText).toLowerCase()) ||
    String(option.data?.hubspotId)?.toLowerCase().includes(String(searchText).toLowerCase())
  ) {
    return true;
  }
  return false;
};

export const cleanObject = (obj) =>
  Object.fromEntries(
    Object.entries(obj)
      .filter(
        ([key, value]) =>
          (key !== 'parentDealershipId' && key !== 'chargifyId') ||
          (value !== undefined && value !== '' && value !== null),
      )
      .map(([key, value]) => [key, value === undefined ? null : value])
      .filter(([key]) => validAttributes.includes(key)),
  );

export const fetchTimezone = async (lat, lng) => {
  try {
    const timestamp = Math.floor(Date.now() / 1000);
    const response = await axios.get(`https://maps.googleapis.com/maps/api/timezone/json`, {
      params: {
        location: `${lat},${lng}`,
        timestamp,
        key: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
      },
    });
    return response.data.timeZoneId || 'Unknown';
  } catch (error) {
    console.error('Error fetching timezone:', error);
    return 'Undefined';
  }
};
